import cookieInfo from "@alife/bc-cookie-info";
export default (localPrice: string | number) => {
  let locale = 'en-US';
  if (cookieInfo.getBuyerLocale() && cookieInfo.getBuyerSite()) {
    locale = cookieInfo.getBuyerLocale()?.split('_')[0] + '-' + cookieInfo.getBuyerSite();
  }
  return Intl.NumberFormat(locale, {
    style: "currency",
    currency: cookieInfo.getBuyerCurrency() || 'USD',
    useGrouping: true,
  }).format(Number(localPrice))
}